// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jNy9hGf7p30a9MpplM8R{min-height:3rem}", "",{"version":3,"sources":["webpack://./src/pages/Piece/PieceWorks/components/ReportForm.sass"],"names":[],"mappings":"AAAA,sBAAoB,eAAe","sourcesContent":[".actTemplateControl{min-height:3rem}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actTemplateControl": "jNy9hGf7p30a9MpplM8R"
};
export default ___CSS_LOADER_EXPORT___;
